import * as React from 'react'
import {observer} from 'mobx-react'
import {EpikQueryParam} from '@raisenow/epik'
import {useStores} from '../../../../lib/MobXProvider'
import {DynamicSlotName} from '../../../../lib/DynamicSlotName'
import {WidgetApi} from '../../../../lib/WidgetApi'
import {WidgetView} from '../../../../lib/WidgetView'
import {DynamicSlot} from '../../../dynamic/DynamicSlot'
import {RippleWrapper} from '../../../wrappers/RippleWrapper'
import {IconWarning} from '../../../ui/Icons'
import {TestModeBar} from '../../../ui/TestModeBar'

///////////////////////////////////////////////////////////////////////////////

export const SubscriptionCancel = observer(() => {
  const {api} = useStores<{api: WidgetApi}>()
  const {uiTransitionTimeout: timeout} = api.computedConfig

  const backToSubscription = () => {
    setTimeout(async () => {
      api.epik.updateCurrentUrl({
        params: {
          [EpikQueryParam.VIEW]: undefined,
        },
      })
      await api.ui.scrollToTop()
      api.ui.focusWidgetElementBySelector(
        '.subscription-details .actions button',
      )
    }, timeout)
  }
  const cancelSubscription = () => {
    setTimeout(async () => {
      await api.cancelSubscription()
      api.epik.updateCurrentUrl({
        params: {
          [EpikQueryParam.VIEW]: WidgetView.SUBSCRIPTION_CANCEL_RESULT,
        },
      })
      await api.ui.scrollToTop()
    }, timeout)
  }

  return (
    <section className="subscription-cancel">
      <div
        className="thank-you-text"
        dangerouslySetInnerHTML={{
          __html: api.trans('blocks.subscription_cancel.thank_you_text_html'),
        }}
      />

      <div className="header">
        <div className="title">
          <IconWarning />
          <h2 className="text">
            {api.trans('blocks.subscription_cancel.subtitle')}
          </h2>
        </div>
      </div>

      <DynamicSlot name={DynamicSlotName.SUBSCRIPTION_CANCEL_START} />

      <div
        className="main"
        dangerouslySetInnerHTML={{
          __html: api.trans('blocks.subscription_cancel.text_html'),
        }}
      />

      <DynamicSlot name={DynamicSlotName.SUBSCRIPTION_CANCEL_END} />

      <TestModeBar />

      <div className="actions">
        <RippleWrapper>
          <button
            type="button"
            className="btn btn-primary action-save"
            onClick={cancelSubscription}
          >
            <span className="btn-text">
              {api.trans('blocks.subscription_cancel.cancel')}
            </span>
          </button>
        </RippleWrapper>

        <RippleWrapper>
          <button
            type="button"
            className="btn action-back"
            onClick={backToSubscription}
          >
            <span className="btn-text">
              {api.trans('blocks.subscription_cancel.back')}
            </span>
          </button>
        </RippleWrapper>
      </div>
    </section>
  )
})
